import { render } from "./FirstStep.vue?vue&type=template&id=07a306c2&scoped=true"
import script from "./FirstStep.vue?vue&type=script&lang=js"
export * from "./FirstStep.vue?vue&type=script&lang=js"

import "./FirstStep.vue?vue&type=style&index=0&id=07a306c2&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a306c2"]])

export default __exports__